<template>
  <v-dialog
    v-model="model"
    transition="dialog-bottom-transition"
    v-bind:content-class="dialogClasses"
    :max-width="maxWidth"
    :fullscreen="fullscreen && $vuetify.breakpoint.xsOnly"
    scrollable
    :persistent="persistent"
  >
    <v-card
      :height="height"
      :max-width="maxWidth"
      class="ma-0 pa-0"
      style="overflow-x: hidden !important"
    >
      <v-card-title class="ma-0 pa-0">
        <vetalfa-small-header
          v-if="smallHeader"
          :isNavigationDialog="!(fullscreen && $vuetify.breakpoint.xsOnly)"
          :backMethod="
            () => {
              model = false;
            }
          "
          :title="title"
          closable
        >
        </vetalfa-small-header>
        <slot name="tabs"></slot>
        <slot name="header"></slot>
      </v-card-title>
      <v-card-text style="overflow-x: hidden !important" class="ma-0 pa-0">
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style>
.vetalfa-dialog-desktop-fulscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: relative;
  overflow-y: auto;
  top: 0;
  left: 0;
}
</style>

<script>
import labels from "@/constants/labels.js";
export default {
  props: {
    title: {
      type: String,
      default: "Título",
      required: false,
    },
    toggleModel: {
      type: Boolean,
      default: false,
      required: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: true,
      required: false,
    },
    maxWidth: {
      type: String,
      default: "768px",
      required: false,
    },
    bottom: {
      type: Boolean,
      default: true,
      required: false,
    },
    smallHeader: {
      type: Boolean,
      default: true,
      required: false,
    },
    height: {
      type: Number,
      default: null,
      required: false,
    },
  },
  watch: {
    toggleModel(val) {
      this.model = val;
    },
    model(val) {
      if (val) {
        this.dialogClasses = "";
        if (!!this.height) {
          this.dialogClasses = "vetalfa-dialog-desktop-fulscreen ";
        }
        this.dialogClasses +=
          this.bottom && this.$vuetify.breakpoint.xsOnly
            ? "v-bottom-sheet"
            : "";
        this.$emit("dialogOpen");
      } else {
        this.$emit("dialogClose");
      }
    },
  },
  computed: {},
  data() {
    return {
      labels,
      model: false,
      dialogClasses: "",
    };
  },
};
</script>